export default __webpack_public_path__ + "static/media/CS-Septiembre25.8779a1db.webp";